import axios, { AxiosResponse } from 'axios';

export const getAnnouncements = (params): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportalsync/open-api/announcements', { params });
};

export const downloadAnnouncement = (params): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportalsync/open-api/announcements/file', {
        params,
        responseType: 'blob',
    });
};
